export class PenDimensionPipeDto {
  public static ApiUrl = 'api/pen-dimension-pipe';

  Id: number;
  PenDimensionId: number;
  Placement: number;
  PenPipeSizeId: number;
  PenPipeSDRId: number;
  PipeSegmentLength: number;
  PipeSegments: number;
}

export enum PenDimensionPipePlacementEnum {
  BottomRing = 0, // Bunnring
  InnerPipe = 1, // Innerst
  OuterPipe = 2, // Ytterst
  FirstMiddlePipe = 3, // Første midtrør
  SecondMiddlePipe = 4, // Andre midtrør
}

export type PenDimensionPipePlacements = (typeof PenDimensionPipePlacementEnum)[keyof typeof PenDimensionPipePlacementEnum];

export const PenDimensionpipePlacementTranslation: { [key in PenDimensionPipePlacements]: string } = {
  '0': 'pens.bottomRing',
  '1': 'pens.innerPipe',
  '2': 'pens.outerPipe',
  '3': 'pens.firstMiddlePipe',
  '4': 'pens.secondMiddlePipe',
};
